<template>
    <div>
        <v-text-field
            outlined
            dense
            hide-details
            v-model="input"
            :v-validate="validation"
            :error-messages="errorMsgs"
            :label="label"
            :data-vv-name="label"
            :data-vv-as="label"
            @keydown="prevent"
            @focus="focus()"
            @blur="format()"
            :prefix="currency"
        ></v-text-field>
    </div>
    
</template>
<script>
    export default {
        props: {
            currency: {
                type: String,
                default: '£'
            },
            errorMsgs: {
                type: Array,
                default: () => []
            },
            label: {
                type: String,
                default: 'Amount'
            },
            validation: {
                type: String,
                default: 'required|numeric'
            },
            
        },
        data() {
            return {
                display: '',
                input: '',

                value: null,
                focused: false 
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(value) {
                    if (value !== null) {
                        this.formatDisplay();
                        // this.input = this.display;
                    }
                }
            }
        },
        methods: {
            prevent(e) {
                if (e.key === '.' && this.input.includes('.')) {
                    e.preventDefault();
                }
                else if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab' && e.key !== '.') {
                    e.preventDefault();
                } 
            },

            format() {
                if (this.input) {
                    // Strip non-numeric characters (e.g., commas) for processing
                    let cleanedInput = this.input.replace(/,/g, '');

                    // Check if the input is a valid number using a regex
                    if (!/^\d*\.?\d+$/.test(cleanedInput)) {
                        this.value = null;
                        this.display = '';
                        return;
                    }

                    // Ensure proper formatting to two decimal places without scientific notation
                    let [integerPart, decimalPart = ""] = cleanedInput.split('.');
                    decimalPart = decimalPart.slice(0, 2).padEnd(2, '0'); // Ensure 2 decimal places

                    this.value = `${integerPart}.${decimalPart}`;

                    // Format display with commas
                    this.formatDisplay();

                    // Update the input to show the formatted display value
                    this.input = this.display;
                } else {
                    this.value = null;
                    this.display = '';
                }

                // emit the value to v-model
                this.$emit('input', this.value);
                this.$emit('change');
                this.focused = false;
            },

            formatDisplay() {
                // Split the value into integer and decimal parts
                let [integerPart, decimalPart] = this.value.split('.');

                // Add commas to the integer part
                integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                // Recombine the integer and decimal parts
                this.display = `${integerPart}.${decimalPart}`;
            },

            focus() {
                if (this.value !== null) {
                    // Strip formatting (commas) to show raw value
                    this.input = this.value.replace(/,/g, '');
                }

                this.focused = true;
            },

            setValue(value) {
                this.value = value;
                this.input = this.value;    
                this.format();
            }
        }

    }
</script>